import styled from 'styled-components';

import { xdlColorText } from '@xingternal/tokens';

export const StyledCompanyLink = styled.a`
  margin: 0;
  display: flex;
  color: ${xdlColorText};
  word-break: break-word;
`;
